// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".discovery-form[data-v-0c72427a] {\n  width: 100%;\n  height: 100%;\n  min-height: 100vh;\n}\n.discovery-form__loading[data-v-0c72427a] {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--v-gray_10-base);\n}", ""]);
// Exports
module.exports = exports;
